import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Schema from 'modules/custom_resources/store/models/customResources/Schema'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import TableBodyRow from './_Row'

interface Props {
  schema: Schema
  fields: Field[]
  values?: Value[]
  attachableId: number
}

const TableBodyComponent = ({ schema, fields, values = [], attachableId }: Props) => (
  <Table.Body>
    {values.length === 0 && (
      <Table.Blank colSpan={fields.length + 1} text={i18n.t('custom_tables.empty')} />
    )}
    {values.map((value, key) => (
      <TableBodyRow
        key={key}
        attachableId={attachableId}
        fields={fields}
        schema={schema}
        value={value}
      />
    ))}
  </Table.Body>
)

export default observer(TableBodyComponent)
